Jelly.Interface.Fade_Out_And_Remove = function(Element)
{
	// Fades out and removes an element
// 	Jelly.jQuery(Element).fadeOut("fast", function() {Jelly.jQuery(Element).remove();});
// TODO breaks dialogues if removes after fade out (since it's gone by the time they are completed)
	Jelly.jQuery(Element).removeClass("Visible");
	// TODO - why wasn't .remove() in there before? Anyway, did it now, experimentally, 2/28/2016 and hope it's good
	Jelly.jQuery(Element).fadeOut("fast", function() {Jelly.jQuery(this).remove();});
	
};